import React from 'react';
import withLazyLoad from 'utils/withLazyLoad';
import withPid from 'utils/withPid';
import Slider from 'components/Slider';

import Market from '../../components/Market';
import './style.scss';

const LAOHU: React.FC = () => {
    return (
        <>
            <Slider className="banner laohu-root">
                <div className="laohu-performance">
                    <div className="site-main" data-animation="a-flyTopIn">
                        <h5 className="brand">LAOHU</h5>
                        <h3>Share Your Performance on Social Media </h3>
                        <p>Investment performance is available for sharing on Twitter and Instagram</p>
                    </div>
                </div>
                <div className="laohu-free">
                    <div className="site-main" data-animation="a-flyTopIn">
                        <h5 className="brand">LAOHU</h5>
                        <h3>Free, real-time</h3>
                        <p>stock quotes without delays</p>
                    </div>
                </div>
                <div className="laohu-no-min">
                    <div className="site-main" data-animation="a-flyTopIn">
                        <h5 className="brand">LAOHU</h5>
                        <h3>No minimum</h3>
                        <p>deposit requirement</p>
                    </div>
                </div>
            </Slider>
            <Market />
        </>
    );
};

export default withLazyLoad(withPid('brand')(LAOHU));
